module.exports = __webpack_public_path__ + "img/Logo_Sentbiz_white_02.a36bd96c.png";